import React from 'react'
import strings from '../../lang/strings'

export default function ItemFaq(props) {
  const {info, toggle} = props

  return (
    <div>
      {
        !info.open &&
        <div className='faq-title d-flex cursor-point' onClick={toggle}>
          <div className='fs-16 sm-fs-14 f-b color-878c91'>{strings._q}</div>
          <div className='fs-16 sm-fs-14 f-sb color-878c91 ml-20 flex-full text-line'>{info.qa_title}</div>
          <img className='' src={'/assets/image/a6_d_g.png'} height={20} alt='' />
        </div>
      }
      {
        info.open &&
        <div className='cursor-point faq-answer' onClick={toggle}>
          <div className='d-flex'>
            <div className='fs-16 sm-fs-14 f-b color-878c91'>{strings._q}</div>
            <div className='fs-16 sm-fs-14 f-sb color-0f4c81 ml-20 flex-full text-line'>{info.qa_title}</div>
            <img className='' src={'/assets/image/a6_u_g.png'} height={20} alt='' />
          </div>
          <div className='mt-20 mr-80 sm-mr-60 d-flex'>
            <div className='fs-16 sm-fs-14 f-b color-0f4c81'>{strings._a}</div>
            <div className='ml-20 flex-full fs-16 sm-fs-14'>{info.qa_note}</div>
          </div>
        </div>
      }
    </div>
  )
}

